import { Link } from 'react-router-dom';

export interface ExploreItem {
  label: string;
  icon: string;
  to?: string;
  href?: string;
  primary?: boolean;
}

interface KeepExploringProps {
  title?: string;
  subtitle?: string;
  items: ExploreItem[];
  bg?: 'white' | 'soft' | 'dark';
}

export default function KeepExploring({
  title = 'Keep Exploring',
  subtitle,
  items,
  bg = 'soft',
}: KeepExploringProps) {
  const bgClass =
    bg === 'dark'
      ? 'bg-gray-950'
      : bg === 'white'
      ? 'bg-white border-t border-gray-100'
      : 'bg-rose-50/60 border-t border-rose-100/60';

  const labelClass =
    bg === 'dark' ? 'text-pink-400' : 'text-rose-400';

  const titleClass =
    bg === 'dark' ? 'text-white' : 'text-gray-900';

  const subtitleClass =
    bg === 'dark' ? 'text-white/50' : 'text-gray-400';

  return (
    <section className={`py-16 ${bgClass}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className={`text-xs font-bold tracking-widest uppercase mb-3 ${labelClass}`}>
          {title}
        </p>
        {subtitle && (
          <p className={`text-sm mb-8 max-w-md mx-auto leading-relaxed ${subtitleClass}`}>
            {subtitle}
          </p>
        )}
        <div className="flex flex-wrap justify-center gap-3 mt-6">
          {items.map((item) => {
            const baseClass = item.primary
              ? 'inline-flex items-center gap-2 px-7 py-3 bg-pink-600 text-white text-sm font-bold rounded-full hover:bg-pink-700 transition-colors cursor-pointer whitespace-nowrap'
              : bg === 'dark'
              ? 'inline-flex items-center gap-2 px-6 py-3 bg-white/8 border border-white/15 text-white/70 hover:text-white hover:bg-white/14 text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap'
              : 'inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-200 text-gray-700 hover:border-pink-200 hover:text-pink-700 text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap';

            if (item.href) {
              return (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={baseClass}
                >
                  <i className={`${item.icon} text-base`}></i>
                  {item.label}
                </a>
              );
            }
            return (
              <Link key={item.label} to={item.to ?? '/'} className={baseClass}>
                <i className={`${item.icon} text-base`}></i>
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
